

export function isBlank(value) {
  return value === undefined ||
         value === null ||
         value === false ||
         (typeof value === 'string' && value.trim() === '')
}

export function isPresent(value) {
  return !isBlank(value)
}

function elementSupportsValueAttribute(element) {
  return element instanceof HTMLInputElement ||
    element instanceof HTMLTextAreaElement ||
    element instanceof HTMLOptionElement ||
    element instanceof HTMLSelectElement
}

export function setElementValue(element, value) {
  element.dataset.value = value
  if (elementSupportsValueAttribute(element)) {
    element.type === "checkbox" ?
      element.checked = value :
      element.value = value
    element.dispatchEvent(new Event('change'))
  } else {
    element.innerText = value
  }
}

/**
 *
 * @param element The source HTML element from which to respond and send values to the form
 * @returns {*|null|string} The element's value, sorted selected values for multi-select, the value of
 * a checkbox while it is checked, or the answer a radio group holds -- reported by every member of
 * that group alike, so the group counts as one answered field rather than several blank ones.
 */
/**
 * The answer a radio group holds, whichever of its members is asked.
 *
 * A group carries one answer between them, so an unchecked option is not a blank answer -- it is the
 * same answer, given by a sibling. Reporting per element would make every required group look
 * unsatisfied for as long as it had more than one option.
 *
 * @param {HTMLInputElement} radio one member of the group
 * @returns {string|null} the checked value, or null while the group is unanswered
 */
function checkedRadioValue(radio) {
  if (!radio.name) return radio.checked ? radio.value : null

  const scope = radio.form ?? radio.ownerDocument
  const checked = scope.querySelector(`input[type="radio"][name="${radio.name.replaceAll('"', '\\"')}"]:checked`)
  return checked ? checked.value : null
}

export function elementValue(element) {
  if (elementSupportsValueAttribute(element)) {
    switch(element.type) {
      case "checkbox":
        return element.checked ?
          element.value :
          null
      case "radio":
        return checkedRadioValue(element)
      case "select-multiple":
        return sortedMultiSelectOptionValues(element)
      default:
        return element.value
    }
  } else {
    return element.type === 'fieldset' ?
      null :
      element.innerText
  }
}

export function inputElement(element) {
  return element instanceof HTMLInputElement ||
    element instanceof HTMLTextAreaElement ||
    element instanceof HTMLSelectElement
}

function elementSupportsDisabledAttribute(element) {
  return element instanceof HTMLInputElement ||
    element instanceof HTMLButtonElement ||
    element instanceof HTMLFieldSetElement ||
    element instanceof HTMLOptGroupElement ||
    element instanceof HTMLOptionElement ||
    element instanceof HTMLTextAreaElement ||
    element instanceof HTMLSelectElement
}
export function setElementEnabled(element, enabled) {
  if (elementSupportsDisabledAttribute(element)) {
    element.disabled = !enabled
  } else {
    element.classList.toggle('disabled', !enabled)
  }
}

export function sortedMultiSelectOptionValues(element) {
  return Array.from(element.selectedOptions)
    .map(option => option.value)
    .sort()
    .join()
}
